import React, { useEffect, useState } from 'react';
import errorPage from '../assets/img/error-page.svg';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setPageTitle } from '../store/slices/pageTitleSlice';

const ErrorPage = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setPageTitle('Error | Spire360'));
    }, []);

    return (
        <main className='main'>
            <div className="main__content-full px-5 pt-4 pb-5">
                <div className="row align-items-center h-100">
                    <div className='col-md-6 text-md-end'>
                        <img src={errorPage} className='img-fluid vh-65'/>
                    </div>
                    <div className='col-md-6'>
                        <h1 className='text-secondary'>Oops...</h1>
                        <h3 className='text-base'>Something went wrong</h3>
                        <div className='text-light mb-6'>The information you are looking for doesn't exist or another error occurred</div>
                        <Link to="/" className='btn btn-secondary px-6 rounded'>
                        <span className="material-symbols-outlined fs-16 align-text-top">arrow_back_ios</span>
                        Go Back
                        </Link>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ErrorPage;